import { Heading } from '@cinch-labs/design-system'
import { FeatureCard, FeatureCardProps } from '../feature-card'
import styles from './why-choose.module.css'

interface Row {
  columns: FeatureCardProps[]
}

interface GridRowsProps {
  rows: Row[]
}

export interface WhyChooseProps {
  title: string
  content: GridRowsProps[]
}

export const WhyChoose = (props: WhyChooseProps) => {
  const { title, content } = props
  const cards = content[0]?.rows[0]?.columns ?? []

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <Heading element="h2" className={styles.title}>
          {title}
        </Heading>
      </div>
      <div className={styles.cardsWrapper}>
        {cards?.map((card: FeatureCardProps) => (
          <FeatureCard {...card} key={card.title} />
        ))}
      </div>
    </div>
  )
}
